export const DANGER = {
  DARKEST: '#880603',
  DARKER: '#AE2B28',
  DARK: '#CD332F',
  DEFAULT: '#E53935',
  LIGHT: '#F89E9C',
  LIGHTER: '#FFCDD2',
  LIGHTEST: '#FFEBEE',
} as const;
